import { createReducer,on } from "@ngrx/store";
import { Dashboard } from "./dashboard";
import { dashboardFetchAPISuccess } from "./dashboard.action";
 
export const initialState: ReadonlyArray<Dashboard> = [];

export const DashboardReducer  = createReducer(
    initialState,

    on(dashboardFetchAPISuccess, (state, { allData }) => {
        return allData;
      })
);

